import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonRouterOutlet, IonSplitPane} from '@ionic/react';
import { IonReactHashRouter } from '@ionic/react-router';
import CVRisk from './pages/CVRisk';
import RenalRisk from './pages/RenalRisk';
import BodyMassIndex from './pages/BodyMassIndex';
import Menu from './components/Menu';
import Recommendations from './pages/Recommendations';
import Description from './pages/Description';
import HowToBloodPressure from './pages/HowToBloodPressure'
import Alarms from './pages/Alarms'
import HowToOptimizeRisk from './pages/HowToOptimizeRisk'
import { SettingsProvider } from './utils/Settings';
import ReactTooltip from 'react-tooltip';
import { GA4R } from 'ga-4-react';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';

const App: React.FC = () => {
  return (
    <GA4R code="G-0JQER4H8J5" config={{debug_mode: false, send_page_view: false}}>
    <SettingsProvider>
      <IonApp>
        <ReactTooltip className="tooltip" scrollHide={true}/>
        <IonReactHashRouter>
          <IonSplitPane contentId="main">
            <Menu />
            <IonRouterOutlet id="main">
              {/* <Route path="/optimizerisk" component={HowToOptimizeRisk} exact={true} />*/}
              <Route path="/howtobloodpressure" component={HowToBloodPressure} exact={true} />
              <Route path="/description" component={Description} exact={true} />
              <Route path="/cvrisk" component={CVRisk} exact={true} />
              <Route path="/recommendations" component={Recommendations} exact={true} />
              <Route path="/bodymassindex" component={BodyMassIndex} exact={true} />
              <Route path="/renalrisk" component={RenalRisk} exact={true} />
              <Route path="/alarms" component={Alarms} exact={true} />
              <Route path="/" render={() => <Redirect to="/description" />} exact={true} />
            </IonRouterOutlet>
          </IonSplitPane>
        </IonReactHashRouter>
      </IonApp>
    </SettingsProvider>
    </GA4R>
  );
};

export default App;
